import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../Episode.Styled';
import { dateFormat, EPISODE_AOR_URL } from '../../../../constants';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import {
  getAorcmForm,
  newAorcm,
} from '../../../../redux/episode/aorvmTab/episodeAorcmSlice';
import AorcmDialog from './aorcmDialog';

function AorCm(props) {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [aorForm, setAorForm] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    page: 1,
  });
  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    aorForm.page,
    aorForm.pageSize,
  ]);

  const fetchData = async () => {
    setAorForm((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_AOR_URL}/${episodeId}/AORCMs?PageNumber=${aorForm.page}&PageSize=${aorForm.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setAorForm((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          recordEpdCntID: item.recordEpdCntID ? item.recordEpdCntID : '-',
          startDate: item.startDate
            ? moment(item.startDate).format(dateFormat).split('T')[0]
            : '-',
          endDate: item.endDate
            ? moment(item.endDate).format(dateFormat).split('T')[0]
            : '-',
          roleType: item.roleType?.value ? item.roleType?.value : '-',
          caseManagerOrParoleAgent: item.caseManagerOrParoleAgent?.value
            ? item.caseManagerOrParoleAgent?.value
            : '-',
        })),
      }));
    }).catch((e) => alert(e));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const aorRowClick = (rowData) => {
    const aorcmFormUrl = `${EPISODE_AOR_URL}/AORCMs/${rowData.recordEpdCntID}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    dispatch(getAorcmForm({ aorcmFormUrl, authorization }));
    setOpen(true);
  };

  const openNewAORCM = () => {
    const aorcmDetail = {
      newAorcm: true,
      caseManagerOrParoleAgent: '',
      roleType: '',
      recordEpdCntID: '',
      startDate: '',
      endDate: '',
    };
    dispatch(newAorcm(aorcmDetail));
    setOpen(true);
  };

  const columnsData = [
    {
      field: 'recordEpdCntID',
      headerName: 'Record EpdCntID',
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      sortable: false,
      flex: 1,
      type: 'date',
      minWidth: 80,
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      sortable: false,
      flex: 1,
      type: 'date',
      minWidth: 80,
    },
    {
      field: 'roleType',
      headerName: 'Role Type',
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'caseManagerOrParoleAgent',
      headerName: 'Case Manager or Parole Agent Name',
      sortable: false,
      flex: 1,
      minWidth: 150,
    },
  ];

  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant='h5'>
            To edit AOR/CM please click on particular row
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          <Button variant='contained' onClick={() => openNewAORCM()}>
            New AOR/CM
          </Button>
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={aorForm.data}
              rowCount={aorForm.total}
              rowsPerPageOptions={[10, 25, 50]}
              pageSize={aorForm.pageSize}
              pagination
              paginationMode='server'
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setAorForm((old) => ({ ...old, pageSize: newPageSize }))
              }
              onPageChange={(newPage) => {
                setAorForm((old) => ({ ...old, page: newPage + 1 }));
              }}
              loading={aorForm.isLoading}
              onRowClick={(param) => aorRowClick(param.row)}
              disableColumnFilter
              disableColumnMenu
            />
          </div>
        </div>
      </div>      
      </DataGridContainer>
      <AorcmDialog
        open={open}
        setOpen={setOpen}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        episodeId={episodeId}
        openBackdrop={openBackdrop}
        fetchData={fetchData}
      />
    </>
  );
}

export default AorCm;
